export const SessionExpiredModal = ({ onLogin }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1100
  }}>
    <div style={{
      backgroundColor: 'white', borderRadius: '16px', padding: '2rem',
      maxWidth: '500px', width: '90%',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        <div style={{
          width: '48px', height: '48px', borderRadius: '50%',
          backgroundColor: '#ebf8ff', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#3182ce" strokeWidth="2"/>
            <path d="M12 6v6l4 2" stroke="#3182ce" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h2 style={{ margin: 0, color: '#2d3748', fontSize: '1.5rem', fontWeight: '700' }}>Session Expired</h2>
      </div>

      <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: '1.6', marginBottom: '2rem' }}>
        You've been logged out due to inactivity or session expiry. Please log in again to continue.
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={onLogin}
          style={{
            padding: '0.75rem 2rem', backgroundColor: '#3182ce', color: 'white',
            border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600',
            cursor: 'pointer', transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#2b6cb0'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#3182ce'}
        >
          Go to Login
        </button>
      </div>
    </div>
  </div>
);

export const GenericErrorModal = ({ message, onClose }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1100
  }}>
    <div style={{
      backgroundColor: 'white', borderRadius: '16px', padding: '2rem',
      maxWidth: '500px', width: '90%',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        <div style={{
          width: '48px', height: '48px', borderRadius: '50%',
          backgroundColor: '#fff5f5', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#e53e3e" strokeWidth="2"/>
            <path d="M12 8v4M12 16h.01" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <h2 style={{ margin: 0, color: '#2d3748', fontSize: '1.5rem', fontWeight: '700' }}>Error</h2>
      </div>

      <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: '1.6', marginBottom: '2rem' }}>
        {message}
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={onClose}
          style={{
            padding: '0.75rem 2rem', backgroundColor: '#e53e3e', color: 'white',
            border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600',
            cursor: 'pointer', transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#c53030'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#e53e3e'}
        >
          OK
        </button>
      </div>
    </div>
  </div>
);
